import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from "@mui/material";
import MovieIcon from '@mui/icons-material/Movie';import "./NoContent.scss";

export const NoContent = () => {
  const languageStrs = useSelector((store) => store.editdata.languageStrs);
  return (
    <div className="no-content">
    <div className="no-content-container">
          <span className='no-content-span'></span>
          <div className="no-content-center">
              <div className="no-content-wrap">
                  <div className="no-content-box-1 box">
                    <MovieIcon  className='no-content-icon'/>
                    <MovieIcon  className='no-content-icon'/>
                  </div>
                  <div className="no-content-box-2 box">
                      <MovieIcon  className='no-content-icon'/>
                      <MovieIcon  className='no-content-icon'/>
                  </div>
              </div>
          </div>
      </div>
      <Typography className='warning-text' variant='h2'>{languageStrs.you_dont_have_content_here}</Typography>
  </div>    
  
  )
}
